import { NgModule } from '@angular/core';
import { FormModelsModule } from 'src/shared/form-models/form-models.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/shared/material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { QuoteListStateModule } from './+state/quote-list-state.module';
import { QuoteListComponent } from './quote-list.component';
import { QuoteListFiltersComponent } from './filters/quote-list-filters.component';
import { RouterModule } from '@angular/router';
import { AlertsModule } from 'src/shared/alerts/alerts.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		AlertsModule,
		RouterModule,
		FormModelsModule,
		QuoteListStateModule,
	],
	declarations: [QuoteListComponent, QuoteListFiltersComponent],
})
export class QuoteListModule {}
